import { type SearchParams } from '@direct-frontend/modules-router';
import { OperatorType, stringifyFilterItems } from '@adv-frontend/filters';
import { type OpenApiSchemaProductVariantRequestFilter } from '#shared/api/schema';
import { FILTERS_OPEN } from '#shared/lib/constants';
import { CHARACTERISTIC_FILTER_ID } from '../constants/characteristicFilter';

export const getCharacteristicRequestFilter = (slug: string): OpenApiSchemaProductVariantRequestFilter => {
    return {
        field: CHARACTERISTIC_FILTER_ID,
        operator: 'Eq',
        values: [slug],
    };
};

export const getCharacteristicFilterSearchParams = (slug: string): SearchParams => {
    const filterString = stringifyFilterItems([
        {
            filterId: CHARACTERISTIC_FILTER_ID,
            operator: OperatorType.Eq,
            value: slug,
            id: '0',
            wasAutoFocused: false,
        },
    ]);

    return {
        filter: filterString,
        [FILTERS_OPEN]: 'true',
    };
};
